// Erreurs de verification d'un code promo (checkDiscountCode) et leur message traduit.
//
// Le reducer range ces constantes dans `orders.error` ; les ecrans (panier, paiement,
// recapitulatif) les traduisent ici. Un code reserve a un autre compte (GT-261007-HVGQ)
// recoit la meme reponse qu'un code inconnu, pour ne pas confirmer l'existence du code d'une
// autre agence : le message indique seulement qu'un code d'agence demande d'etre connecte
// avec le compte qui l'a recu (cas d'un client B2B qui reserve sans etre connecte).
export const DISCOUNT_ERROR_CITY = "Discount not valid for this city";
export const DISCOUNT_ERROR_INVALID = "Invalid discount code";
export const DISCOUNT_ERROR_LOGIN = "Discount login required";
export const DISCOUNT_ERROR_FAILED = "Error applying discount code";
// Code « une fois par compte » (WELCOME10) deja utilise avec ce compte
export const DISCOUNT_ERROR_USED = "Discount already used by this account";

type T = (key: string, options?: Record<string, unknown>) => string;

/** Code d'erreur a partir de la reponse HTTP de /api/discount/isValidate. */
export const discountErrorFromStatus = (status?: number, code?: string): string => {
  if (code === "already_used_by_account") return DISCOUNT_ERROR_USED;
  if (status === 404 || status === 400) return DISCOUNT_ERROR_INVALID;
  if (status === 401) return DISCOUNT_ERROR_LOGIN;
  return DISCOUNT_ERROR_FAILED;
};

export const discountErrorMessage = (error: string | null | undefined, t: T): string => {
  switch (error) {
    case DISCOUNT_ERROR_CITY:
      return t("checkout_discount_city_not_allowed", { defaultValue: "This discount is not valid for the selected city" });
    case DISCOUNT_ERROR_LOGIN:
      return t("checkout_discount_login_required", { defaultValue: "Please sign in to use a promo code." });
    case DISCOUNT_ERROR_FAILED:
      return t("checkout_discount_check_error", { defaultValue: "The code could not be checked. Please try again." });
    case DISCOUNT_ERROR_USED:
      return t("checkout_discount_already_used", { defaultValue: "You have already used this code with your account: it can be used only once per account." });
    default:
      return t("checkout_invalid_discount_code_hint", {
        defaultValue: "Invalid code. If this code was issued to your agency, sign in with the account that received it."
      });
  }
};
